export default "__VITE_ASSET__NeIz3w2h__"